export const Apis = {
  login: "/api/login",
  sendmessage: "/api/sendmessage",
};
